// FLAGS: none
// Tailwind text colour for a client check-in score, on a 0-100 scale. The MUI-era twin in theme/colors.js bands
// the same idea on a 0-5 scale — they are not interchangeable.
export const getScoreColorClass = (score: number): string => {
  if (score >= 0 && score < 45) {
    return "text-indigo-800"; // primaryDarkBlue
  }
  if (score >= 45 && score < 75) {
    return "text-sky-600"; // primaryBlue
  }
  return "text-emerald-500"; // primaryGreen
};
